import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Route } from 'react-router-dom';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { IRootState } from '../interfaces';
import { getProfileRequest } from '../action';
//import { AppRoutes } from '../config';
import Loader from '../components/Loader/Loader';

class Authenticated extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      isAuthenticated: false,
      isLoading: true,
    };
  }
  componentDidMount = () => {
    this.props.getProfileInfo();
  };
  componentDidUpdate = async (prevProps: any) => {
    const { location } = prevProps;
    const { pathname } = location;
    // const { params } = computedMatch;
    if (pathname !== this.props.location.pathname) {
      if (
        this.props.path === "./"

      ) {
        // Nothing happens here
      } else {
        this.setState({
          isAuthenticated: false,
          isLoading: true,
        });
        this.props.getProfileInfo();
      }
    }
    const { profileReducer } = this.props;
    if (
      prevProps.profileReducer &&
      profileReducer &&
      profileReducer.isLoading !== prevProps.profileReducer.isLoading
    ) {
      // if (profileReducer.isError) {
      //   // console.log(('above remove');

      //   localStorage.removeItem('userToken');
      //   this.props.history.push('/');
      // }
      if (
        profileReducer.profileInfo &&
        Object.entries(profileReducer.profileInfo).length
      ) {
        // TO redirect user to profile page if all the required details not updated yet.
        // if (!profileReducer.profileInfo.profileCompleted) {
        //   this.props.history.push(AppRoutes.MY_ACCOUNT);
        // }
        this.setState({
          isAuthenticated: true,
          isLoading: false,
        });
      }
    }
  };
  authenticated = () => {
    const {
      component: Component,
      layout: Layout,
      profileReducer,
      ...rest
    } = this.props;

    const { isLoading, isAuthenticated } = this.state;

    return (
      <Route
        {...rest}
        render={props => (
          <Layout {...props}>
            {isLoading ? (
              <Loader />
            ) : isAuthenticated ? (
              <Component {...props} />
            ) : null}
          </Layout>
        )}
      />
    );
  };
  render() {
    return this.authenticated();
  }
}

const mapStateToProps: any = (state: IRootState) => ({
  profileReducer: state.profileReducer,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getProfileInfo: () => {
      dispatch(getProfileRequest());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Authenticated));
